<div class="modal flex-direction-column gap-54 padding-15px">
  <h2>O Contato irá para o fluxo - {{tituloFluxo}}</h2>
  <div>
    <p>Selecione qual etapa ele deve seguir</p>
    @if(etapas.length === 0){
      <div>O template não pode ser enviado pois não ha nenhuma etapa disponível para redirecionar a seu canal.</div>
    }
    <app-select-one
      class="select-template"
      [listaInput]="etapas"
      [itemSelecionado]="etapaSelecionada"
      [pularPrimeiraSelecao]="true"
      campo="tituloGenerico"
      (selecionarItem)="selecionarEtapa($event)"
      heightFormField="35px">
    </app-select-one>
  </div>

  <div class="center-center flex-direction-row-reverse gap-5">
    <app-button-padrao
      style="width: 100%;"
      [width]="'100%'"
      label="Salvar"
      backgroundColor="var(--verde-padrao)"
      color="white"
      (buttonClick)="confirmar()">
    </app-button-padrao>
    <app-button-padrao
      style="width: 100%;"
      [width]="'100%'"
      label="Cancelar"
      backgroundColor="white"
      color="var(--vermelho-padrao)"
      (buttonClick)="cancelar()"
      borderColor="var(--vermelho-padrao)"
      borderStyle="solid"
      borderWidth="1px"></app-button-padrao>
  </div>
</div>
